module.exports = __webpack_public_path__ + "officialStatic/img/hnczLogo.2f70b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/hnczLogo.png
// module id = eRyQ
// module chunks = 0